<template>
  <div class="commonWrap">
    <div class="left">
      <secondaryMenu
        ref="secondaryMenu"
        :route-name="routeName"
        :is-collapse="false"
        :defaultactive="defaultactive"
        :class-obj="classObj"
        permission-key=""
        :project-type="false"
        :externalShowList="externalShowList"
      >
      </secondaryMenu>
    </div>
    <div class="right" :style="{ width: hideSidebar ? '100%' : 'calc(100% - 130px)' }">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import secondaryMenu from "@/CommonDP/components/secondaryMenu/secondaryMenu";
import { mapState } from "vuex";

export default {
  // eslint-disable-next-line
  name: "templateOne",
  components: {
    secondaryMenu
  },
  data() {
    return {
      defaultactive: {
        path: ""
      },
      showSubMenu: true,
      routeName: "",
      oneMenuHideList: false
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      flatProjectRoutes: (state) => state.router.flatProjectRoutes,
      flatRoutes: (state) => state.router.flatRoutes,
      authProjectRoutes: (state) => state.router.authProjectRoutes,
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isShowMyEnterprise: (state) => state.projectMg.isShowMyEnterprise
    }),

    externalShowList() {
      const name = this.$route.matched.at(-2)?.name;
      const meauList = this.flatRoutes.find(({ permissionKey }) => permissionKey === name) || this.flatProjectRoutes.find(({ permissionKey }) => permissionKey === name);
      meauList.sub = meauList.childList.map((item) => {
        item.sub = item.childList || [];
        item.name = item.permissionName;
        item.path = item.location;
        if (item.sub?.length) {
          item.sub.map((item) => {
            item.sub = item.childList || [];
            item.name = item.permissionName;
            item.path = item.location;
          });
        }
        return item;
      });
      meauList.name = meauList.permissionName;
      meauList.path = meauList.location;
      return meauList ? [meauList] : [];
    },

    hideSidebar() {
      return (this.oneMenuHideList && this.externalShowList[0]?.childList?.length === 1) || this.externalShowList[0]?.childList?.length === 0;
    },

    sidebar() {
      return this.$store.state.app.sidebar;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    }
  },
  watch: {
    $route() {
      this.defaultactive.path = this.$route.meta.prouteName;
      this.routeName = this.$route.meta.pname;
    }
  },
  created() {},
  async mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.commonWrap {
  display: flex;
  width: 100%;
  height: 100%;

  .left {
    width: 130px;
    // height: calc(100% - 28px);
    background-color: #fff;
    margin-right: 14px;
  }

  // .right {
  // margin-top: 14px;
  // margin-bottom: 14px;
  // width: calc(100% - 28px);
  // flex: 1;
  // }
}
</style>
